import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Line } from "react-chartjs-2";
// Constants - Functions
import { getRandomColor } from "../../../../config/functions";
// Components
import Graphic from "./graphic";

const SuccessRatesPlot = ({ recordings }) => {
  const [positions, setPositions] = useState([]);
  const [successRatesDatasets, setSuccessRatesDatasets] = useState([]);
  const [t] = useTranslation("global");

  useEffect(() => {
    let successRatesInputs = [];
    const processedData = {};
    recordings.forEach((entry, index) => {
      successRatesInputs.push(index + 1);
      const successRates = entry.successRates || {};
      for (const key in successRates) {
        if (!processedData[key]) processedData[key] = [];
        processedData[key].push({ x: index + 1, y: successRates[key] });
      }
    });

    const datasets = Object.keys(processedData).map((key) => {
      const currentColor = getRandomColor();
      return {
        label: key,
        data: processedData[key],
        backgroundColor: currentColor,
        borderColor: currentColor,
      };
    });

    setPositions(successRatesInputs);
    setSuccessRatesDatasets(datasets);

    return () => {
      setPositions([]);
      setSuccessRatesDatasets([]);
    };
  }, [recordings]);

  const data = {
    labels: positions,
    datasets: successRatesDatasets,
  };

  return (
    <Graphic
      Title={t("reports.accuracyGraphic.title")}
      Type={Line}
      data={data}
      axisY={t("reports.accuracyGraphic.axisY")}
      axisX={t("reports.accuracyGraphic.axisX")}
    />
  );
};

export default SuccessRatesPlot;
